import { grid, maxWidthContainer, minBreakpoints, theme } from '@noths/polaris-client-ribbons-base';
import { mediaQuery } from '@noths/polaris-client-styles';
import { css } from 'styled-components';

const { responsiveText, spacing } = theme;

export const container = css`
  ${grid}
  ${maxWidthContainer}
  grid-row-gap: 0;
`;

export const topOffsetImageMarginContainer = css`
  ${mediaQuery(
    { min: minBreakpoints.L },
    css`
      padding-bottom: ${spacing.xl}px;
    `,
  )};
`;

export const content = css`
  text-align: center;
  grid-column: span 12;
  margin-top: -${spacing.md}px;
  margin-bottom: ${spacing.xl}px;

  ${mediaQuery(
    { min: minBreakpoints.M },
    css`
      margin-top: 0;
      margin-bottom: 0;
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;
      order: 1;
      grid-column: span 6;
    `,
  )}

  ${mediaQuery(
    { min: minBreakpoints.XL },
    css`
      grid-column: 2 / span 4;
    `,
  )};
`;

export const lightTextContent = css`
  * {
    color: var(--neutral-white-base);
  }
`;

export const darkTextContent = css`
  * {
    color: var(--neutral-black-base);
  }
`;

export const imageWrapper = css`
  grid-column: span 12;

  ${mediaQuery(
    { min: minBreakpoints.M },
    css`
      order: 2;
      grid-column: span 6;
    `,
  )};

  ${mediaQuery(
    { min: minBreakpoints.XL },
    css`
      grid-column: 7 / span 5;
    `,
  )};
`;

const sharedStyles = css`
  margin: ${spacing.md}px 0 0;
  * {
    margin: 0;
    font-size: inherit;
    line-height: inherit;
  }
`;

export const heading = css`
  margin: ${spacing.xl}px 0 0;

  ${mediaQuery(
    { min: minBreakpoints.M },
    css`
      margin: 0;
    `,
  )}
`;

export const headingWithButton = css`
  ${responsiveText.HEADING.XL};
`;

export const headingWithoutButton = css`
  ${responsiveText.HEADING.XL};
`;

export const innerHeading = css`
  display: block;
  > span {
    display: inline-block;
  }
`;

export const innerHeadingUnderline = css`
  box-shadow: inset 0px -12px 0px var(--underlineColor);
`;

export const subHeading = css`
  ${sharedStyles};
`;

export const subHeadingWithButton = css`
  ${responsiveText.BODY.MD};

  ${mediaQuery(
    { min: minBreakpoints.L },
    css`
      ${responsiveText.HEADING.SM};
    `,
  )};
`;

export const subHeadingWithoutButton = css`
  ${responsiveText.BODY.MD};

  ${mediaQuery(
    { min: minBreakpoints.L },
    css`
      ${responsiveText.HEADING.XS};
    `,
  )};

  ${mediaQuery(
    { min: minBreakpoints.XL },
    css`
      ${responsiveText.HEADING.SM};
    `,
  )};
`;

export const copy = css`
  ${responsiveText.BODY.XS};
  ${sharedStyles};
`;

export const buttonContainer = css`
  margin: ${spacing.xl}px 0 0;

  ${mediaQuery(
    { min: minBreakpoints.M },
    css`
      margin-bottom: 0;
    `,
  )}

  ${mediaQuery(
    { min: minBreakpoints.L },
    css`
      margin: ${spacing.xxl}px 0 0;
    `,
  )}
`;
